// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__22erC","alertIcon":"ConfirmModal_alertIcon__1woBb"};